import { SettingsOfficeListTable, SettingsOfficeForm } from "./component";

type OfficeAddressPropType = {
  handleScrollToTop: () => void;
};

export default function OfficeAddress({
  handleScrollToTop,
}: OfficeAddressPropType) {
  return (
    <div>
      <SettingsOfficeForm />
      <SettingsOfficeListTable handleScrollToTop={handleScrollToTop} />
    </div>
  );
}
